import React from 'react';
import { Box, Chip, Typography, Tooltip } from '@mui/material';
import { useAuth } from '../context/AuthContext';

const TIERS = [
  { key: null,      label: 'Admin',  color: '#c084fc', bg: '#3a1a6e' },
  { key: 'premium', label: 'Nerds+', color: '#f5a623', bg: '#2a1a05' },
  { key: 'free',    label: 'Free',   color: '#2ea84b', bg: '#0a2a14' },
  { key: 'basic',   label: 'Basic',  color: '#9eb8d0', bg: '#1a2e44' },
];

export default function AdminViewBar() {
  const { realIsAdmin, viewAsTier, setViewAsTier } = useAuth();
  if (!realIsAdmin) return null;

  return (
    <Box sx={{
      position: 'fixed', bottom: 16, left: '50%', transform: 'translateX(-50%)',
      zIndex: 9999, display: 'flex', alignItems: 'center', gap: 1,
      backgroundColor: 'rgba(8,14,28,0.97)', border: '1px solid #3a1a6e',
      borderRadius: 99, px: 2, py: 0.75, boxShadow: '0 4px 24px rgba(192,132,252,0.2)',
      backdropFilter: 'blur(8px)',
    }}>
      <Typography sx={{ fontSize: '0.68rem', color: '#6a4a9a', fontWeight: 700, mr: 0.5, whiteSpace: 'nowrap' }}>
        🔧 VIEW AS:
      </Typography>
      {TIERS.map(t => (
        <Tooltip key={String(t.key)} title={t.key === null ? 'Your real admin view' : `Simulate ${t.label} tier`} placement="top" arrow>
          <Chip
            label={t.label}
            size="small"
            onClick={() => setViewAsTier(t.key)}
            sx={{
              cursor: 'pointer', fontWeight: 700, fontSize: '0.68rem', height: 22,
              bgcolor: viewAsTier === t.key || (t.key === null && viewAsTier === null) ? t.bg : 'transparent',
              color: viewAsTier === t.key || (t.key === null && viewAsTier === null) ? t.color : '#4a6080',
              border: viewAsTier === t.key || (t.key === null && viewAsTier === null)
                ? `1px solid ${t.color}66`
                : '1px solid #2a3a50',
              transition: 'all 0.15s',
              '&:hover': { bgcolor: t.bg, color: t.color },
            }}
          />
        </Tooltip>
      ))}
    </Box>
  );
}
